import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import config from '../../config'
import Loader from 'react-loader'
import container from '../../helpers/container'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import ReactTooltip from 'react-tooltip'
import {Row, Col} from 'react-flexbox-grid'
import {
  // Chart,
  Link,
  LinkIcon,
  Tweeter,
  FlaggedFund,
  FamilyGrid,
  Grade,
  SocialButtons
} from '../../components'
import * as searchActions from 'redux/modules/search'
const Styles = require('./Family.css')


/**
 * <FamilyResults 
 *   fundFamily
 * />
 * 
 * Displays results for major fund families. Includes a chart, category
 * breakdowns, tweet button, and stats on ESG and fossil-free funds. Category
 * breakdowns are rendered by <FamilyResultsSectorDetails />.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyResults extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    const high = (
      <span styleName='high-icon'>
        <LinkIcon faclass='fa-exclamation-triangle' nospace/>
      </span>
    )

    const extreme = (
      <span styleName='extreme-icon'>
        <LinkIcon faclass='fa-exclamation-triangle' nospace/>
      </span>
    )

    const a = format.money(fundFamily.pff_all_asset_sum)
    const b = format.perc(fundFamily.pff_all_weight_total)
    const c = convert.int(fundFamily.num_equity_funds)
    const d = format.money(fundFamily.pff_high_asset_sum)
    const e = format.perc(fundFamily.pff_high_weight_total)
    const f = format.money(fundFamily.pff_extreme_asset_sum)
    const g = format.perc(fundFamily.pff_extreme_weight_total)

    return (
      <div>

        <br/>
        <Row>
          <Col xs={12}>
            <div styleName='family-cta'>
              Major fund managers are pouring trillions into the prison
              industrial complex. Share to spread the word.
            </div>
            <Tweeter
              type='family'
              item={ fundFamily }
            />
          </Col>
        </Row>
        <br/>

        <Row>
          <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>

            <FlaggedFund
              isFamily
              totalFunds={convert.int(fundFamily.num_equity_funds)}
              count={convert.int(fundFamily.pff_all_count_sum)}
              weight={convert.float(fundFamily.pff_all_weight_total)}
              label={'flagged'}
            />

          </Col>
          <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
            <div styleName='sector-details-info'>
              <LinkIcon faclass='fa-info-circle' nospace /> For each prison
              industrial complex category, we show the combined exposure of
              the asset manager's U.S.-based equity funds.
            </div>

            <div styleName='sector-details-info-label-energy'>
              <strong>Prison industrial complex</strong>
            </div>

            <FamilyResultsSectorDetails
              type='pp'
              label='Prison industry'
              sublabel='Incarceration and detention facilities, services in facilities, supervision and monitoring'
              count={fundFamily.pff_prisons_count_sum}
              weight={fundFamily.pff_prisons_weight_total}
              asset={fundFamily.pff_prisons_asset_sum}
              currency='US Dollar'
            />

            <FamilyResultsSectorDetails
              type='borders'
              label='Borders industry'
              sublabel='Incarceration and detention facilities, immigrant monitoring and surveillance, militarization of the U.S.-Mexico border'
              count={fundFamily.pff_borders_count_sum}
              weight={fundFamily.pff_borders_weight_total}
              asset={fundFamily.pff_borders_asset_sum}
              currency='US Dollar'
            />

          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div styleName='fam-tots'>
              <div styleName='fam-tot'>
                Flagged investments:
              </div>
              <div styleName='fam-tot-val'>
                {a}, {b} of assets of {c} equity funds
              </div>
              <div styleName='fam-tot'>
                {high} <strong>Higher risk:</strong>
              </div>
              <div styleName='fam-tot-val'>
                {d}, {e} of assets of {c} equity funds
              </div>
              <div styleName='fam-tot'>
                {extreme}
                &nbsp;
                <span styleName='bred'>
                  Private prison operators:
                </span>
              </div>
              <div styleName='fam-tot-val'>
                {f}, {g} of assets of {c} equity funds
              </div>
            </div>
          </Col>
        </Row>

        <div styleName='chart-content-hl-wrap'>
          <p>
            <LinkIcon faclass='fa-info-circle' nospace />&nbsp;
            This data covers open-end mutual funds and exchange-traded funds
            domiciled in the
            U.S. with at least 50% of assets invested in stocks. It
            excludes bond funds, target date funds, and other investment vehicles
            like closed-end funds, collective trusts, and funds domiciled
            outside the U.S. <b>This asset manager may have additional
            prison industrial complex-risk investments in those excluded funds.</b>
          </p>
        </div>

      </div>
    )
  }
}


/**
 * <FamilyResultsSectorDetails
 *   type
 *   label
 *   sublabel
 *   count
 *   weight
 *   asset
 *   currency
 * />
 * 
 * Displays details for a fossil fuel sector, like Carbon Underground 200.
 * Depending on the sector, displays a different icon. Displays label,
 * sublabel, count, weight, asset provided by props.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyResultsSectorDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: this.props.type || null,
      label: this.props.label || null,
      sublabel: this.props.sublabel || null,
      count: this.props.count || null,
      weight: this.props.weight || null,
      asset: this.props.asset || null,
      currency: this.props.currency || null,
    }
  }

  render() {
    const { 
      type,
      label,
      sublabel,
      count,
      weight,
      asset,
      currency
    } = this.state

    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'.svg' )
    // circle icon inactive
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      cleanDirtyStyle = 'detail-sector-'+type+'-active'
      currIcon = iconNormal
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    return (
      <div styleName='detail-sector-wrapper'>
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName={'detail-title-active'}>
            <div>{label}</div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>{sublabel}</div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>

                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.number(count)}
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.money(asset, true, currency, true)}
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      {format.perc(weight)}
                    </div>
                    <div styleName='detail-stat-label'>of fund assets</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-subtitle'>
                      No direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    )
  }
}


/**
 * <FamilyBanner
 *   fundFamily
 * />
 * 
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the 10 families with additional data in config, or just
 * a generic fund family.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div styleName='banner-taglines'>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>Are your retirement funds</span>
                      ) : (
                        <span>Your retirement plan could</span>
                      )
                  }
                </div>
              </div>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>invested with {fundFamily.fund_family_label}?</span>
                      ) : (
                        <span>be invested in prisons</span>
                      )
                  }
                </div>
              </div>
              <div styleName='toolkit'>
                <div styleName='toolkit-info'>
                  Check out our action toolkit and talk to your retirement
                  plan manager
                </div>
                <Link
                  to={config.routes.toolkit}
                  log={analytics.eventToToolkit()}
                  title='Action toolkit'
                >
                  <div styleName='toolkit-action'>
                    Action toolkit<LinkIcon />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that names the fund company
 * at the top of the list of funds and shareclasses for this family.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilySummarySentence extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    return (
      <div styleName='summary'>
        {fundFamily.fund_family_label} funds in our database
      </div>
    )
  }
}


/**
 * <FamilyFundList
 *   fundList
 * />
 * 
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundList: props.fundList || null
    }
  }

  componentWillReceiveProps(props) {
    if (props.fundList) {
      this.setState({
        fundList: props.fundList
      })
    }
  }

  render() {
    const { fundList } = this.state
    if (!fundList) { return null }

    return (
      <div styleName='holding-list'>
        {
          fundList.map((fund, idx) => {
            return (
              <FamilyFundListItem
                fund={fund}
                key={'family-fund-list-item-'+idx}
              />
            )
          })
        }
      </div>
    )
  }
}


/**
 * <FamilyFundListItem 
 *   fund
 * />
 * 
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fund: props.fund || null
    }
  }

  render() {
    const { fund } = this.state
    if (!fund) { return null }

    const {
      fund_id,
      fund_legal_name,
      currency,
      pp_weight,
      borders_weight,
      pff_all_high_weight,
      pff_all_extreme_weight,
      grade_prison_industrial_complex
    } = fund

    return (
      <div styleName='holding'>
        <div styleName='ticker-name-assets'>
          <div styleName='ticker-name'>
            <div styleName='holdings-name'>
              {fund_legal_name}
            </div>
            <FamilyFundListItemTickerLinks shareclasses={fund.shareclass} />
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.perc(pp_weight) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;prison industry
            </div>
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.perc(borders_weight) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;borders industry
            </div>
          </div>
          <div styleName='ticker-assets'>
            <div styleName='ticker-assets-figure'>
              {format.perc(pff_all_high_weight) }
            </div>
            <div styleName='ticker-assets-label'>
              &nbsp;high risk
            </div>
          </div>
        </div>
        <div styleName={'score-wrapper'}>
          <Grade grade={grade_prison_industrial_complex} />
        </div>
      </div>
    )
  }
}


/**
 * <FamilyFundListItemTickerLinks 
 *   shareclasses
 * />
 * 
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItemTickerLinks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareclasses: props.shareclasses || null
    }
  }

  render() {
    const { shareclasses } = this.state
    if (!shareclasses) { return null }

    const tickerUrls = shareclasses.map((e,i)=>{
      const tckr = e.ticker || 'N/A'
      const safeTicker = e.ticker || 'N'
      const url = config.routes.fund + '/' +
        format.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' +
        config.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id

      return {
        ticker: tckr,
        name: e.name,
        url
      }
    })

    if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
      const e = tickerUrls[0]
      return (
        <div styleName='ticker-links'>
            <Link to={e.url} title={e.name}>
              <span styleName='ticker'>See results<LinkIcon/></span>
            </Link>
        </div>
      )
    }

    return (
      <div styleName='ticker-links'>
        {
          tickerUrls.map((e, i)=>{
            return (
              <Link
                key={'holding-link-'+i}
                to={e.url}
                title={e.name}
              >
                { e.ticker === 'N/A' ?
                    <span styleName='ticker'>{e.name}</span> :
                    <span styleName='ticker'>{e.ticker}</span>
                }
              </Link>
            )
          })
        }
      </div>
    )
  }
}


@connect(
  state => ({
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class Family extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      family: props.location.query.q || '',
      searchQuery: '',
      lastResult: null,
      funds: [],
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.familyShareClasses(this.state.family, 1)
  }

  componentWillReceiveProps(props) {
    const q = props.location.query.q || ''
    if (q !== this.state.family) {
      this.familyShareClasses(props.location.query.q, 1)
      window.scroll(0, 0)
      this.setState({
        page: 1,
        family: q,
        searchQuery: '',
        lastResult: null,
        funds: [],
      })
    } else if (props.result && this.state.lastResult !== props.result) {
      this.setState({
        lastResult:props.result,
        funds: this.state.funds.concat(props.result)
      })
    }
  }

  getMoreFunds = () => {
    this.familyShareClasses(this.state.family, this.state.page+1)
  }

  familyShareClasses = (family,page) => {
    page = page || this.state.page
    this.setState({page:page})
    this.props.familyShareClasses(family, page)
  }

  configFundFamily = () => {
    return config.familyFunds.find(
      (family) => family.fund_family_name === this.state.family
    )
  }

  renderSectorDetails = (type, label, sublabel, count, weight, asset, currency) => {
    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'.svg' )
    // circle icon with green slash
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive-slash.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      cleanDirtyStyle = 'detail-sector-'+type+'-active'
      currIcon = iconNormal
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    return (
      <div styleName='detail-sector-wrapper'>
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName={'detail-title-active'}>
            <div>{label}</div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>
                    {sublabel}
                  </div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>
                  <div styleName={'detail-stat-active'}>
                    <div styleName='detail-stat-figure'>
                      {format.number(count)}
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName={'detail-stat-active'}>
                    <div styleName='detail-stat-figure'>
                      {format.money(asset, true, currency, true)}
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName={'detail-stat-active'}>
                    <div styleName='detail-stat-figure'>
                      {format.perc(weight)}
                    </div>
                    <div styleName='detail-stat-label'>of fund assets</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-title'>
                      0 direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    )
  }

  render() {
    if (!(this.state.page !== 1 || !this.props.searching)) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    if (!this.props.location.query.q) {
      return (
        <div styleName='main'>
          <FamilyGrid
            fullGrid
            screen={this.state.screen}
          />
        </div>
      )
    }

    // redirect for SEO
    if (
      this.props.location.query.q.toUpperCase()==='BLACKROCK' ||
      this.props.location.query.q.toUpperCase()==='ISHARES'
    ) {
      this.context.router.push(
        config.routes.families + '?q=BlackRock%2FiShares'
      )
    }

    const { funds } = this.state

    const fundFamily = this.configFundFamily()

    const fileName = format.imgPath(this.state.family)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    const hasMore = (
      this.state.lastResult &&
      this.state.lastResult.length === config.queryMaxFunds
    )

    const urlStart = config.routes.family+'?q='+this.state.family
    const url = config.domain+urlStart

    return (
      <div styleName='main'>
        {container.helmet(this.state.family, '', url)}
        <Loader
          options={{scale: 0.70, top: '2.0rem'}}
          loaded={ this.state.page !== 1 || !this.props.searching}
        >
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>
              <div styleName='name-wrap'>
                <div styleName='name'>
                  <div styleName={fundFamily ? 'name-tag-big' : 'name-tag'}>
                    {fundFamily ? 'Major fund manager' : 'Fund manager'}
                  </div>
                </div>
                <div>
                  { /*
                    fundFamily ?
                      (
                        <SocialButtons
                          message={config.app.title+' - '+fundFamily.name}
                          link={config.routes.families+'?q='+this.state.family}
                        />
                      ) :
                      null
                  */ }
                </div>
              </div>

              <div styleName='name-logo-lbl'>
                {
                  fundFamily ?
                    fundFamily.label :
                    this.state.family
                }
              </div>

              { /*
                hasLogo ?
                  (
                     <div styleName='name-logo'>
                       <div styleName='name-logo-lbl'>
                        {
                          fundFamily ?
                            fundFamily.label :
                            this.state.family
                        }
                      </div>
                      <img
                        styleName='name-logo-img'
                        src={companyLogo}
                        alt={
                          fundFamily ?
                            fundFamily.label :
                            this.state.family
                        }
                      />
                     </div>
                  ) :
                  (
                    <span>{this.state.family}</span>
                  )
              */ }

              { /* <FamilyResults fundFamily={fundFamily} /> */ }

            </div>
          </div>

          <div styleName='holdings-wrapper'>
            <div styleName='holdings'>
              <FamilySummarySentence fundFamily={fundFamily}/>
              <div styleName='holdings-inner'>
                <div styleName='rating-label'>
                  <div styleName='rating-label-line'/>
                  <div styleName='rating-label-info'>
                    Prison industrial complex grade
                  </div>
                </div>
                <FamilyFundList fundList={funds} />
              </div>
            </div>
          </div>
          
          <div styleName='more-funds-wrapper'>
            <Loader
              options={{scale: 0.70, top:'0'}}
              loaded={ !this.props.searching }
            />
            <div styleName='more-funds'>
              <div
                onClick={hasMore ? this.getMoreFunds : null}
                styleName={
                  hasMore ? 'more-funds-button' : 'no-more-funds-button'
                }
              >
                {
                  hasMore ?
                    'Get more funds' : 
                    'No more funds'
                }<LinkIcon faclass='fa-plus-circle'/>
              </div>
              {
                !hasMore ?
                  (
                    <div styleName='no-more-funds-info'>
                      Looking for your favorite fund and can't find it? Sorry,
                      but we don't have everything in our database.
                    </div>
                  ) :
                  null
              }
            </div>
          </div>

          <FamilyBanner fundFamily={fundFamily}/> :

        </Loader>
      </div>
    )
  }
}
